$shm_projects_tests $mol_view
	project_id \
	filter? \
	sub /
		<= Summary $mol_view
			sub / <= summary \
		<= Filter $mol_search
			query? <=> filter? \
		<= Table $mol_view
			sub /
				<= Table_head $mol_view
					sub /
						<= Head_status $mol_view
							sub / \Статус
						<= Head_title $mol_view
							sub / \Сценарий
						<= Head_started $mol_view
							sub / \Последний запуск
						<= Head_duration $mol_view
							sub / \Время
						<= Head_open $mol_view
				<= Rows $mol_list
					rows <= test_rows /
	Test* $mol_view
		sub /
			<= Test_status* $mol_view
				sub / <= test_status* \
			<= Test_info* $mol_view
				sub /
					<= Test_title* $mol_view
						sub / <= test_title* \
					<= Test_source* $mol_view
						sub / <= test_source* \
			<= Test_started* $mol_view
				sub / <= test_started* \
			<= Test_duration* $mol_view
				sub / <= test_duration* \
			<= Test_open* $mol_link
				uri <= test_uri* \
				title \Открыть
				external true
	Empty $mol_view
		sub / \Для проекта пока нет результатов тестов
